import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { Heading } from '@chakra-ui/react';

/**
 * Heading - h1
 *
 * @see Docs https://chakra-ui.com/heading
 */
var HeadingH1 = function HeadingH1(props) {
  return /*#__PURE__*/React__default.createElement(Heading, _extends({
    as: "h1",
    size: "h1"
  }, props));
};
export { HeadingH1 };